import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

const PHOTOS = [
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/5ambat42_IMG_1763.jpeg", caption: "Where it all began — first day of kindergarten", fit: true },
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/3tblfb92_IMG_3193.webp", caption: "Last day at Our Lady of Lourdes — graduation day! 🎓", fit: true },
  { src: "/chase-senior-portrait.jpg", caption: "The official senior portrait — Class of 2026 ✨", fit: true },
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/16fo4d2i_IMG_5484.webp", caption: "Chase finds his name in gold — first campus visit" },
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/wnsc2sr4_IMG_5475.webp", caption: "First steps on the famous purple turf" },
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/kukp5c3t_IMG_5477.webp", caption: "The only purple football field in the country" },
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/ha3q6g84_IMG_5478.webp", caption: "CURRY endzone — where the Colonels play" },
  { src: "https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/m9myiqob_IMG_5479.webp", caption: "Fresh turf, big dreams" },
];

export default function RoadToCurry() {
  return (
    <section id="gallery" className="py-16 md:py-24 max-w-7xl mx-auto px-4 sm:px-6">
      <p className="font-sub text-xs tracking-[0.2em] uppercase font-bold text-purple-400 mb-3">The Journey So Far</p>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase mb-4">
        Road To <span className="text-purple-400">Curry</span>
      </h2>
      <p className="font-sub text-base md:text-lg text-zinc-400 max-w-3xl mb-10">
        From his first day of kindergarten to his last day at Our Lady of Lourdes High School —
        and over 30 college acceptances later — Chase chose Curry. Congratulations, Chase! 💜
      </p>
      <Carousel opts={{ align: "start", loop: true }} className="w-full" data-testid="road-to-curry-carousel">
        <CarouselContent>
          {PHOTOS.map((p, i) => (
            <CarouselItem key={i} className="md:basis-1/2 lg:basis-1/3" data-testid={`gallery-slide-${i}`}>
              <div className="group relative rounded-2xl overflow-hidden bg-zinc-900 border border-white/5 hover:border-purple-500/50 transition-colors duration-300">
                <img src={p.src} alt={p.caption} className={`w-full h-80 ${p.fit ? "object-contain bg-zinc-950 p-2" : "object-cover"} group-hover:scale-105 transition-transform duration-500`} loading="lazy" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-zinc-950 to-transparent pt-16 pb-4 px-5">
                  <p className="font-sub text-sm text-white">{p.caption}</p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious data-testid="gallery-prev-btn" className="hidden sm:flex -left-4 bg-zinc-900 border-white/10 text-white hover:bg-purple-600 hover:text-white" />
        <CarouselNext data-testid="gallery-next-btn" className="hidden sm:flex -right-4 bg-zinc-900 border-white/10 text-white hover:bg-purple-600 hover:text-white" />
      </Carousel>
      <p className="font-sub text-xs text-zinc-500 mt-4 sm:hidden">Swipe to explore →</p>
    </section>
  );
}
